import React from 'react';

const LightBulbIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M13.4509 23.0195H10.5759" stroke="#4B4B4B" />
      <path d="M14.4093 21.1055H9.61758" stroke="#4B4B4B" />
      <path d="M12.0134 0.980469V3.85547" stroke="#4B4B4B" />
      <path d="M3.88101 4.34766L5.9146 6.38028" stroke="#4B4B4B" />
      <path d="M20.1449 4.34766L18.1122 6.38028" stroke="#4B4B4B" />
      <path d="M0.992584 12.4805H3.86758" stroke="#4B4B4B" />
      <path d="M23.0342 12.4805H20.1592" stroke="#4B4B4B" />
      <path
        d="M17.7634 12.479C17.7645 11.49 17.5105 10.5175 17.026 9.65539C16.5414 8.79327 15.8427 8.0707 14.9973 7.55749C14.152 7.04428 13.1885 6.75779 12.2001 6.72569C11.2116 6.69359 10.2316 6.91697 9.35473 7.37424C8.47784 7.83152 7.73371 8.50724 7.19425 9.3361C6.65478 10.165 6.33822 11.119 6.27514 12.1059C6.21206 13.0928 6.4046 14.0794 6.83415 14.9702C7.26371 15.861 7.91576 16.6259 8.7273 17.1911C8.8542 17.2794 8.95787 17.397 9.02946 17.534C9.10105 17.671 9.13843 17.8233 9.13843 17.9779V18.7082C9.13843 18.8352 9.18891 18.9571 9.27877 19.047C9.36863 19.1368 9.49051 19.1873 9.61759 19.1873H14.4093C14.5363 19.1873 14.6582 19.1368 14.7481 19.047C14.8379 18.9571 14.8884 18.8352 14.8884 18.7082V17.9769C14.8884 17.8224 14.9258 17.6701 14.9974 17.5331C15.069 17.3961 15.1726 17.2784 15.2996 17.1902C16.0603 16.6623 16.6818 15.958 17.1109 15.1376C17.54 14.3171 17.7639 13.4049 17.7634 12.479Z"
        stroke="#4B4B4B"
      />
    </g>
  </svg>
);

export default LightBulbIcon;
